/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitRankingItem } from './MonitRankingItem';
import {
    MonitRankingItemFromJSON,
    MonitRankingItemFromJSONTyped,
    MonitRankingItemToJSON,
} from './MonitRankingItem';

/**
 * 
 * @export
 * @interface MonitPopularityRankingResult
 */
export interface MonitPopularityRankingResult {
    /**
     * 
     * @type {string}
     * @memberof MonitPopularityRankingResult
     */
    domain: string;
    /**
     * 
     * @type {Array<MonitRankingItem>}
     * @memberof MonitPopularityRankingResult
     */
    rankings: Array<MonitRankingItem>;
}

/**
 * Check if a given object implements the MonitPopularityRankingResult interface.
 */
export function instanceOfMonitPopularityRankingResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "rankings" in value;

    return isInstance;
}

export function MonitPopularityRankingResultFromJSON(json: any): MonitPopularityRankingResult {
    return MonitPopularityRankingResultFromJSONTyped(json, false);
}

export function MonitPopularityRankingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPopularityRankingResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'rankings': ((json['rankings'] as Array<any>).map(MonitRankingItemFromJSON)),
    };
}

export function MonitPopularityRankingResultToJSON(value?: MonitPopularityRankingResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'rankings': ((value.rankings as Array<any>).map(MonitRankingItemToJSON)),
    };
}

